(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-recommendations"]) return;
  try {
    
  const productRecommendationsSection = document.querySelector('.product-recommendations');

  if (productRecommendationsSection) {
    const observer = new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;

            // Initialize Swiper after recommendations load
            new Swiper('.recommendations__slider', {
              slidesPerView: 4,
              spaceBetween: 5,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              breakpoints: {
                320: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 4 }
              }
            });
          }
        })
        .catch(e => console.error(e));
    }, {rootMargin: '0px 0px 200px 0px'});

    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
